import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = { noRestore: Boolean }

  connect() {
    this.element.addEventListener('submit', this.exemptPageFromCache)
  }

  disconnect() {
    this.element.removeEventListener('submit', this.exemptPageFromCache)
  }

  // Exempt the page we're submitting from Turbo's snapshot cache so a later
  // restoration visit (Back button) refetches it fresh instead of restoring a
  // stale snapshot. The form equivalent of ui--link#exemptPageFromCache, for
  // forms that mutate data and redirect on success (e.g. modal forms).
  exemptPageFromCache = () => {
    if (!this.noRestoreValue) return

    window.Turbo?.cache?.exemptPageFromCache()
  }
}
